import React, { ReactNode } from "react";
import { IOrderContextType, useOrderController } from "./useOrderController";

export type { IOrderContextType } from "./useOrderController";
export type {
  CancelAllOrderFailure,
  CancelAllOrdersResponse,
} from "./types";

export const OrderContext = React.createContext<IOrderContextType | undefined>(
  undefined
);

interface IOrderContextProviderProps {
  children: ReactNode;
}

// NOTE: This provider depends on MarketInstrumentContext (via
// useInstrumentResolver, used for realtime order enrichment), so it MUST be
// mounted inside <MarketInstrumentContextProvider> (see routes/index.tsx).
// Do not hoist it above that provider or realtime orders lose instrument
// resolution. Every useOrder() consumer must render within this boundary.
export function OrderContextProvider({
  children,
}: IOrderContextProviderProps) {
  const value = useOrderController();
  return (
    <OrderContext.Provider value={value}>{children}</OrderContext.Provider>
  );
}
